import { IconKey } from '@nx-frontend/shared/types/icon';
import { IconsMap } from './icon';

export function IconPreview() {
  return (
    <div>
      {Object.keys(IconsMap).map((iconName) => {
        return (
          <div className="flex">
            {IconsMap[iconName as IconKey]} - {iconName}
          </div>
        );
      })}
    </div>
  );
}
